import { Navigate, useParams } from 'react-router-dom';

import { LoadingState } from '../../components/loading-state';
import { useGetNoteDetailsQuery } from '../../store/api';
import { resourceDetailPath } from '../../utils/resource-routes';

/**
 * Forwards the pre-consolidation note URLs to the canonical one (GDN-2726).
 *
 * A redirect, not a view — the note renders in exactly one place now. Admin
 * pages cross-link to notes by bare id (transcript detail, encounter detail,
 * note-processing sessions) without carrying the organization the canonical
 * URL needs, so it's resolved from the record here.
 */
export default function NoteRedirect() {
  const { noteId: scoped, id: legacy } = useParams<{
    noteId?: string;
    id?: string;
  }>();
  const noteId = scoped || legacy || '';

  const { data, isLoading } = useGetNoteDetailsQuery(
    { noteId },
    { skip: !noteId },
  );

  if (!noteId) return <Navigate to="/admin-v2" replace />;
  if (isLoading) return <LoadingState message="Opening note..." />;

  const organizationId =
    data?.note?.organization_id ?? data?.provider?.organization_id;
  if (!organizationId) return <Navigate to="/admin-v2" replace />;

  return (
    <Navigate
      to={resourceDetailPath({ organizationId }, 'note', noteId)}
      replace
    />
  );
}
